import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    mounted () {
        // Overwriting base render method with actual data.
        this.renderChart({
        labels: ['1', '1', '1', '2', '1', '1', '1', '2', '2', '1', '3'],
        datasets: [
                    {
                        label: 'Статистика случаев короновируса',
                        backgroundColor: [
                            '#41B883',
                            '#E46651',
                            '#00D8FF',
                        ],

                        data: [34, 343, 432, 23, 123, 5643, 234, 12, 5674, 234, 12]
                    }
                ]
        }, {responsive: true, maintainAspectRatio: false} )
    }
}